import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/layout/Header';
import Sidebar from '../components/layout/Sidebar';
import NotificationPanel from '../components/notification/NotificationPanel';
import { dashboardAPI } from '../services/api';
import { useQuery } from 'react-query';

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const { user, tenant, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // 获取未读通知数量
  const { data: notificationsData } = useQuery(
    'notifications',
    () => dashboardAPI.getNotifications(),
    {
      refetchInterval: 60000, // 每分钟刷新一次
    }
  );

  const unreadNotifications = notificationsData?.notifications?.length || 0;

  // 当路由变化时关闭移动端侧边栏
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  const handleLogout = async () => {
    const result = await logout();
    if (result.success) {
      navigate('/login');
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleNotifications = () => {
    setNotificationsOpen(!notificationsOpen);
  };

  if (!user || !tenant) {
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      {/* 移动端侧边栏遮罩 */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-gray-600 bg-opacity-75 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      <Header
        user={user}
        tenant={tenant}
        unreadNotifications={unreadNotifications}
        onToggleSidebar={toggleSidebar}
        onToggleNotifications={toggleNotifications}
        onLogout={handleLogout}
      />

      {/* 通知面板 */}
      {notificationsOpen && (
        <NotificationPanel onClose={() => setNotificationsOpen(false)} />
      )}

      <div className="flex-1 flex overflow-hidden">
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          currentPath={location.pathname}
        />
        
        <main className="flex-1 overflow-y-auto bg-gray-100 p-4 sm:p-6">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>

      {/* 页脚 */}
      <footer className="bg-white border-t border-gray-200 py-4 px-6">
        <div className="flex flex-col sm:flex-row justify-between items-center">
          <div className="text-sm text-gray-600 mb-2 sm:mb-0">
            <span className="font-medium">{tenant.name}</span> - 昊天安全管理平台
          </div>
          <div className="text-xs text-gray-500">
            © {new Date().getFullYear()} 版权所有 | 版本 2.0.0
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MainLayout;